import { TurnInto } from 'types'
import {
  Caption,
  Computer,
  Facebook,
  Globe,
  Google,
  Heart,
  Instagram,
  LinkedIn,
  Pinterest,
  Shopify,
  Stars,
  TikTok,
  Twitter,
  WhatsApp,
  YouTube,
} from 'blaze-ui/icons'
import { Tools as ToolsIcon } from 'blaze-ui/icons/20/Tools'
import { Content as ContentIcon } from 'blaze-ui/icons/20/Content'
import { Marketplaces } from 'blaze-ui/icons/20/Marketplaces'
import { Video } from 'blaze-ui/icons/20/Video'
import { Emails as EmailsIcon } from 'blaze-ui/icons/20/Emails'
import { Ads as AdsIcon } from 'blaze-ui/icons/20/Ads'
import { Website } from 'blaze-ui/icons/20/Website'
import { Sales as SalesIcon } from 'blaze-ui/icons/20/Sales'
import { CustomerService } from 'blaze-ui/icons/20/CustomerService'
import { Recruiting as RecruitingIcon } from 'blaze-ui/icons/20/Recruiting'
import { ProductDescriptions as ProductDescriptionsIcon } from 'blaze-ui/icons/20/ProductDescriptions'
import { Popular as PopularIcon } from 'blaze-ui/icons/20/Popular'
import { Brainstorm as BrainstormIcon } from 'blaze-ui/icons/20/Brainstorm'
import { StartBlank as StartBlankIcon } from 'blaze-ui/icons/20/StartBlank'
import { Other as OtherIcon } from 'blaze-ui/icons/20/Other'
import {
  Category,
  ChannelKeyType,
  CreationCategoryChannels,
  EmailsChannels,
  MarketplaceChannels,
  MarketplaceTabs,
  MarketplaceCategories,
  SocialMediaChannels,
  SocialMediaTabs,
  ToolsChannels,
  VideosChannels,
  VideosTabs,
  WizardCardInfo,
  SocialMediaCategories,
  MarketplaceChannelsV2,
  VideoCategories,
  EmailCategories,
  EmailsChannelsV2,
  OtherChannels,
  OtherCategories,
  V2Channels,
} from './Types'
import { WizardTab } from './WizardTabs/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { Group } from '../Catalogue/Types'
import { flatMap } from 'lodash'
import { ForYou } from './Sections/ForYou'
import { Tools } from './Sections/Tools'
import { SocialMedia } from './Sections/SocialMedia'
import { Content } from './Sections/Content'
import { Ads } from './Sections/Ads'
import { ProductDescriptions } from './Sections/ProductDescriptions'
import { Websites } from './Sections/Websites'
import { Sales } from './Sections/Sales'
import { CustomerSupport } from './Sections/CustomerSupport'
import { Recruiting } from './Sections/Recruiting'
import { Marketplace } from './Sections/Marketplace'
import { Videos } from './Sections/Videos'
import { Emails } from './Sections/Emails'
import { NewDocumentButtonProps } from './WizardButton/Types'
import { NewDocListItemProps } from '../WizardsDrawer/WizardsDrawerV3/ListItem/Types'
import { StartBlank } from './Sections/StartBlank'
import { Brainstorm } from './Sections/Brainstorm'
import { AdvancedTools } from './Sections/AdvancedTools'
import { Popular } from './Sections/Popular'
import { WizardCategory } from './WizardCategoryCard/Types'
import { InstagramBrand } from 'blaze-ui/icons/35/InstagramBrand'
import { FacebookBrand } from 'blaze-ui/icons/35/FacebookBrand'
import { LinkedInBrand } from 'blaze-ui/icons/35/LinkedInBrand'
import { TwitterBrand } from 'blaze-ui/icons/35/TwitterBrand'
import { TiktokBrand } from 'blaze-ui/icons/35/TiktokBrand'
import { Other } from './Sections/Other'

export const CATEGORIES_MOBILE: Category[] = [
  { name: 'For You', title: 'For You', component: ForYou },
  { name: 'Tools', title: 'Tools', icon: ToolsIcon, component: Tools },
  { name: 'Social media', title: 'Social Media', icon: Heart, component: SocialMedia },
  { name: 'Blog/SEO', title: 'Blog/SEO', icon: ContentIcon, component: Content },
  { name: 'Marketplaces', title: 'Marketplace', icon: Marketplaces, component: Marketplace },
  { name: 'Video', title: 'Video', icon: Video, component: Videos },
  { name: 'Ads', title: 'Ads', icon: AdsIcon, component: Ads },
  { name: 'Emails', title: 'Emails', icon: EmailsIcon, component: Emails },
  {
    name: 'Product Descriptions',
    title: 'Product Descriptions',
    icon: ProductDescriptionsIcon,
    component: ProductDescriptions,
  },
  { name: 'Website', title: 'Websites', icon: Website, component: Websites },
  { name: 'Sales', title: 'Sales', icon: SalesIcon, component: Sales },
  { name: 'Customer Service', title: 'Customer Support', icon: CustomerService, component: CustomerSupport },
  { name: 'Recruiting', title: 'Recruiting', icon: RecruitingIcon, component: Recruiting },
]

export const CATEGORIES_DESKTOP: Category[] = [
  { name: 'For You', title: 'For You', component: ForYou },
  { name: 'Popular', title: 'Popular', icon: PopularIcon, component: Popular },
  { name: 'Brainstorm', title: 'Brainstorm Ideas', icon: BrainstormIcon, component: Brainstorm },
  { name: 'Start Blank', title: 'Start Blank', icon: StartBlankIcon, component: StartBlank },
  { name: 'Social media', title: 'Social Media', icon: Heart, component: SocialMedia },
  { name: 'Blog/SEO', title: 'Blog/SEO', icon: ContentIcon, component: Content },
  { name: 'Marketplaces', title: 'Marketplace', icon: Marketplaces, component: Marketplace },
  { name: 'Video', title: 'Video', icon: Video, component: Videos },
  { name: 'Tools', title: 'Advanced Tools', icon: ToolsIcon, component: AdvancedTools },
  { name: 'Ads', title: 'Ads', icon: AdsIcon, component: Ads },
  { name: 'Emails', title: 'Emails', icon: EmailsIcon, component: Emails },
  { name: 'Other', title: 'Other', icon: OtherIcon, component: Other },
]

export const FOR_YOU_CHANNELS: ChannelKeyType[] = [
  ChannelType.LinkedInPosts,
  ChannelType.FacebookPost,
  ChannelType.TweetThread,
  ChannelType.BlogPost,
  ChannelType.GoogleAds,
  'pinterest',
  'tik-tok-post',
  'instagram-portrait-post',
  'instagram-reel',
  'instagram-story',
  ChannelType.YoutubeScript,
  ChannelType.FacebookAds,
]

export const TOOLS_CHANNELS: ToolsChannels = {
  ideas: [GenerationType.Brainstorm],
  generate: [
    GenerationType.Campaign,
    GenerationType.InstagramPlanning,
    GenerationType.FacebookPlanning,
    GenerationType.LinkedInPlanning,
    GenerationType.TwitterPlanning,
    GenerationType.SEOPlanning,
    GenerationType.ContentPlan,
  ],
  turn_into: [
    TurnInto.DocsIntoContent,
    TurnInto.AudioIntoContent,
    TurnInto.WebsitesIntoContent,
    TurnInto.VideoIntoContent,
  ],
}

export const SOCIAL_MEDIA_TABS: WizardTab<SocialMediaTabs>[] = [
  { name: 'popular', label: 'Popular', inactiveIcon: <Stars color="black" />, activeIcon: <Stars color="white" /> },
  {
    name: 'linkedIn',
    label: 'LinkedIn',
    inactiveIcon: <LinkedIn size={24} />,
    activeIcon: <LinkedIn size={24} color="white" />,
  },
  {
    name: 'facebook',
    label: 'Facebook',
    inactiveIcon: <Facebook size={24} />,
    activeIcon: <Facebook size={24} color="white" />,
  },
  {
    name: 'instagram',
    label: 'Instagram',
    inactiveIcon: <Instagram size={24} />,
    activeIcon: <Instagram size={24} color="white" />,
  },
  {
    name: 'twitter',
    label: 'X/Twitter',
    inactiveIcon: <Twitter size={24} />,
    activeIcon: <Twitter size={24} color="white" />,
  },
  {
    name: 'tiktok',
    label: 'Tiktok',
    inactiveIcon: <TikTok size={24} />,
    activeIcon: <TikTok size={24} color="white" />,
  },
  {
    name: 'youtube',
    label: 'YouTube',
    inactiveIcon: <YouTube size={24} />,
    activeIcon: <YouTube size={24} color="white" />,
  },
  {
    name: 'pinterest',
    label: 'Pinterest',
    inactiveIcon: <Pinterest size={24} />,
    activeIcon: <Pinterest size={24} color="white" />,
  },
  {
    name: 'whatsapp',
    label: 'WhatsApp',
    inactiveIcon: <WhatsApp size={24} />,
    activeIcon: <WhatsApp size={24} color="white" />,
  },
]

export const SOCIAL_MEDIA_CATEGORIES: WizardCategory<SocialMediaCategories>[] = [
  {
    name: 'instagram',
    label: 'Instagram',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_1_b1d50f.png',
  },
  {
    name: 'facebook',
    label: 'Facebook',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_cirth1.png',
  },
  {
    name: 'linkedIn',
    label: 'LinkedIn',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-1_oc5ogs.png',
  },
  {
    name: 'twitter',
    label: 'X/Twitter',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_3_kqwwl2.png',
  },
  {
    name: 'tiktok',
    label: 'TikTok',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-2_hsqruz.png',
  },
  {
    name: 'youtube',
    label: 'YouTube',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-3_tbmtf3.png',
  },
  {
    name: 'pinterest',
    label: 'Pinterest',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-4_bfkhk3.png',
  },
  {
    name: 'whatsapp',
    label: 'WhatsApp',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_2_pwjwmw.png',
  },
]

export const POPULAR_SOCIAL_MEDIA_CHANNELS: ChannelKeyType[] = [
  'linkedin-post',
  'instagram-square-post',
  'instagram-story',
  'instagram-reel',
]

export const SOCIAL_MEDIA_CHANNELS: SocialMediaChannels = {
  popular: [
    ChannelType.LinkedInPosts,
    ChannelType.FacebookPost,
    ChannelType.Tweets,
    'instagram-square-post',
    'instagram-portrait-post',
    'instagram-reel',
    'instagram-story',
    'pinterest',
    'tik-tok-post',
    ChannelType.YoutubeScript,
  ],
  linkedIn: [
    ChannelType.LinkedInPosts,
    GenerationType.LinkedInPlanning,
    'linkedin-profile-picture',
    'linkedin-post',
    'linkedin-banner',
    ChannelType.LinkedInAds,
  ],
  instagram: [
    ChannelType.InstagramReel,
    ChannelType.InstagramPosts,
    'instagram-portrait-post',
    'instagram-reel',
    'instagram-story',
    GenerationType.InstagramPlanning,
    'instagram-landscape-post',
    'instagram-square-post',
  ],
  facebook: [
    ChannelType.FacebookPost,
    GenerationType.FacebookPlanning,
    'facebook-post',
    'facebook-marketplace',
    'facebook-cover',
    'facebook-profile-picture',
    ChannelType.FacebookAds,
  ],
  twitter: [
    ChannelType.Tweets,
    ChannelType.TweetThread,
    GenerationType.TwitterPlanning,
    'twitter-post',
    'twitter-profile-picture',
    'twitter-cover-image',
  ],
  tiktok: ['tik-tok-post', ChannelType.TikTokScript, 'tik-tok-thumbnail', ChannelType.TikTokAds],
  youtube: [ChannelType.YoutubeScript, 'youtube-channel-art', 'youtube-profile-picture', ChannelType.YoutubeAds],
  pinterest: ['pinterest', ChannelType.PinterestAds],
  whatsapp: ['whatsapp-sticker'],
}

export const SOCIAL_MEDIA_CHANNELS_V2: SocialMediaChannels = {
  popular: ['linkedin-post', 'instagram-portrait-post', 'instagram-story', 'instagram-reel'],
  linkedIn: [
    'linkedin-post',
    GenerationType.LinkedInPlanning,
    'linkedin-profile-picture',
    'linkedin-banner',
    ChannelType.LinkedInAds,
  ],
  instagram: [
    'instagram-portrait-post',
    'instagram-story',
    'instagram-reel',
    GenerationType.InstagramPlanning,
    ChannelType.InstagramReel,
  ],
  facebook: ['facebook-post', 'facebook-profile-picture', 'facebook-cover', GenerationType.FacebookPlanning],
  twitter: [
    'twitter-post',
    ChannelType.TweetThread,
    'twitter-profile-picture',
    'twitter-cover-image',
    GenerationType.TwitterPlanning,
  ],
  tiktok: ['tik-tok-post', ChannelType.TikTokScript, 'tik-tok-thumbnail'],
  youtube: ['youtube-short', ChannelType.YoutubeScript, 'youtube-profile-picture', 'youtube-channel-art'],
  pinterest: ['pinterest'],
  whatsapp: [ChannelType.SMSMessages, 'whatsapp-sticker'],
}

export const MARKETPLACE_TABS: WizardTab<MarketplaceTabs>[] = [
  {
    name: 'all',
    label: 'All',
    inactiveIcon: <Globe size={20} color="black" />,
    activeIcon: <Globe size={20} color="white" />,
  },
  {
    name: 'visual',
    label: 'Visual Product Listings',
    inactiveIcon: <Computer size={20} color="black" />,
    activeIcon: <Computer size={20} color="white" />,
  },
  {
    name: 'product_descriptions',
    label: 'Product Descriptions',
    inactiveIcon: <Caption size={20} color="black" />,
    activeIcon: <Caption size={20} color="white" />,
  },
  {
    name: 'shopify',
    label: 'Shopify',
    inactiveIcon: <Shopify size={24} />,
    activeIcon: <Shopify size={24} color="white" />,
  },
]

export const MARKETPLACE_CATEGORIES: WizardCategory<MarketplaceCategories>[] = [
  {
    name: 'product_descriptions',
    label: 'Product Copy',
    description: 'Generate product descriptions for multiple marketplace websites at once.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/product_copy_xqidzb.png',
  },
  {
    name: 'visual',
    label: 'Product Visual',
    description: 'Make your product photos look like you spent thousands on a photographer.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/product_visual_qhwppn.png',
  },
]

export const MARKETPLACE_CHANNELS: MarketplaceChannels = {
  all: [
    ChannelType.ProductLaunchWebsite,
    ChannelType.ProductLaunchGoogle,
    'facebook-marketplace',
    'ebay',
    'poshmark',
    'depop',
    'mercari',
    'mercadolibre',
    'shopee',
    'lazada',
    ChannelType.ProductLaunchEtsy,
    'etsy',
    'vinted',
    ChannelType.ProductLaunchAmazon,
    'amazon',
    ChannelType.ProductLaunchShopify,
    'shopify-square',
    'pinterest',
  ],
  visual: [
    'facebook-marketplace',
    'ebay',
    'poshmark',
    'depop',
    'mercari',
    'mercadolibre',
    'shopee',
    'lazada',
    'etsy',
    'vinted',
    'amazon',
    'shopify-square',
    'pinterest',
  ],
  product_descriptions: [
    ChannelType.ProductLaunchWebsite,
    ChannelType.ProductLaunchShopify,
    ChannelType.ProductLaunchAmazon,
    ChannelType.ProductLaunchEtsy,
    ChannelType.ProductLaunchGoogle,
  ],
  shopify: ['shopify-square', ChannelType.ProductLaunchShopify],
}

export const MARKETPLACE_CHANNELS_V2: MarketplaceChannelsV2 = {
  visual: [
    'shopify-square',
    'etsy',
    'amazon',
    'ebay',
    'depop',
    'poshmark',
    'mercari',
    'mercadolibre',
    'shopee',
    'lazada',
    'vinted',
    'facebook-marketplace',
  ],
  product_descriptions: [
    ChannelType.ProductLaunchWebsite,
    ChannelType.ProductLaunchGoogle,
    ChannelType.ProductLaunchEtsy,
    ChannelType.ProductLaunchAmazon,
    ChannelType.ProductLaunchShopify,
  ],
}

export const VIDEOS_TABS: WizardTab<VideosTabs>[] = [
  { name: 'popular', label: 'Popular', inactiveIcon: <Stars color="black" />, activeIcon: <Stars color="white" /> },
  {
    name: 'instagram',
    label: 'Instagram',
    inactiveIcon: <Instagram size={24} />,
    activeIcon: <Instagram size={20} color="white" />,
  },
  {
    name: 'youtube',
    label: 'YouTube',
    inactiveIcon: <YouTube size={24} />,
    activeIcon: <YouTube size={24} color="white" />,
  },
  {
    name: 'tiktok',
    label: 'Tiktok',
    inactiveIcon: <TikTok size={24} />,
    activeIcon: <TikTok size={24} color="white" />,
  },
]

export const VIDEO_CATEGORIES: WizardCategory<VideoCategories>[] = [
  {
    name: 'tiktok',
    label: 'TikTok',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-2_hsqruz.png',
  },
  {
    name: 'youtube',
    label: 'YouTube',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-3_tbmtf3.png',
  },
  {
    name: 'instagram',
    label: 'Instagram',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_1_b1d50f.png',
  },
  {
    name: 'facebook',
    label: 'Facebook',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_cirth1.png',
  },
]

export const VIDEOS_CHANNELS: VideosChannels = {
  popular: ['instagram-reel', 'tik-tok-post', 'instagram-story'],
  instagram: [
    'instagram-reel',
    'instagram-story',
    'instagram-portrait-post',
    'instagram-landscape-post',
    'instagram-square-post',
    ChannelType.InstagramReel,
    GenerationType.InstagramPlanning,
  ],
  youtube: ['youtube-short', ChannelType.YoutubeScript, 'youtube-channel-art', ChannelType.YoutubeAds],
  tiktok: ['tik-tok-post', ChannelType.TikTokScript, 'tik-tok-thumbnail', ChannelType.TikTokAds],
}
export const CONTENT_CHANNELS: ChannelKeyType[] = [
  ChannelType.BlogPost,
  ChannelType.BlogIdeas,
  ChannelType.CaseStudy,
  ChannelType.PressRelease,
  GenerationType.Outline,
  GenerationType.ContentBrief,
  GenerationType.SEOPlanning,
]

export const ADS_CHANNELS: ChannelKeyType[] = [
  ChannelType.FacebookAds,
  ChannelType.LinkedInAds,
  ChannelType.TikTokAds,
  ChannelType.YoutubeAds,
  ChannelType.PinterestAds,
  ChannelType.GoogleAds,
  ChannelType.BingAds,
  ChannelType.AmazonAds,
]

export const EMAILS_CHANNELS: EmailsChannels = {
  popular: [
    ChannelType.Newsletter,
    ChannelType.PromotionalEmailSequence,
    ChannelType.NurtureEmailSequence,
    ChannelType.WelcomeSeries,
    ChannelType.ColdOutboundEmailSequence,
    ChannelType.SMSMessages,
  ],
  newsletters: [ChannelType.Newsletter, ChannelType.NewsletterIdeas],
  lifecycle: [ChannelType.PromotionalEmailSequence, ChannelType.NurtureEmailSequence, ChannelType.WelcomeSeries],
  ecommerce: [
    ChannelType.DidntSignUp,
    ChannelType.AbandonedCart,
    ChannelType.LostCustomer,
    ChannelType.SMSMessages,
    ChannelType.WelcomeSeries,
  ],
  sales: [ChannelType.WarmOutboundEmailSequence, ChannelType.ColdOutboundEmailSequence, ChannelType.SMSMessages],
}

export const EMAILS_CHANNELS_V2: EmailsChannelsV2 = {
  newsletters: [ChannelType.NewsletterIdeas, ChannelType.Newsletter],
  lifecycle: [ChannelType.PromotionalEmailSequence, ChannelType.NurtureEmailSequence, ChannelType.WelcomeSeries],
  ecommerce: [ChannelType.DidntSignUp, ChannelType.AbandonedCart, ChannelType.LostCustomer, ChannelType.SMSMessages],
  sales: [ChannelType.WarmOutboundEmailSequence, ChannelType.ColdOutboundEmailSequence],
}

export const EMAIL_CATEGORIES: WizardCategory<EmailCategories>[] = [
  {
    name: 'newsletters',
    label: 'Newsletters',
    description: "Keep your audience hooked with updates and stories they'll love.",
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/newsletters_tyqk8x.png',
  },
  {
    name: 'lifecycle',
    label: 'Lifecycle',
    description: 'Guide new visitors into happy customers with perfectly timed emails.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/lifecycle_meflfb.png',
  },
  {
    name: 'ecommerce',
    label: 'Ecommerce',
    description: 'Turn shoppers into buyers with smart, automated messages.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ecommerce_cgtdxi.png',
  },
  {
    name: 'sales',
    label: 'Sales',
    description: 'Close more deals with persuasive emails that drive action.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/sales_s5ih1u.png',
  },
]

export const PRODUCT_DESCRIPTIONS_CHANNELS: ChannelKeyType[] = [
  ChannelType.ProductLaunchWebsite,
  ChannelType.ProductLaunchShopify,
  ChannelType.ProductLaunchAmazon,
  ChannelType.ProductLaunchEtsy,
  ChannelType.ProductLaunchGoogle,
]

export const WEBSITE_CHANNELS: ChannelKeyType[] = [
  ChannelType.LandingPage,
  ChannelType.AboutUs,
  ChannelType.Pricing,
  ChannelType.Mission,
  ChannelType.FAQs,
  ChannelType.Impact,
]

export const SALES_CHANNELS: ChannelKeyType[] = [
  ChannelType.OnePager,
  ChannelType.ProductDemo,
  ChannelType.PreCallChecklist,
  ChannelType.CallScript,
  ChannelType.Research,
  ChannelType.Testimonial,
  ChannelType.BattleCard,
]

export const CUSTOMER_SUPPORT_CHANNELS: ChannelKeyType[] = [
  ChannelType.ReplyTemplates,
  ChannelType.HelpDocs,
  ChannelType.ReturnPolicy,
  ChannelType.ShippingPolicy,
  ChannelType.CareInstructions,
  ChannelType.BillingAndPayments,
  ChannelType.PaymentConfirmation,
]

export const RECRUITING_CHANNELS: ChannelKeyType[] = [ChannelType.CandidateNurtureSequence, ChannelType.JobDescription]

export const OTHER_CHANNELS: OtherChannels = {
  website: WEBSITE_CHANNELS,
  sales: SALES_CHANNELS,
  customer_support: CUSTOMER_SUPPORT_CHANNELS,
  recruiting: RECRUITING_CHANNELS,
}

export const OTHER_CATEGORIES: WizardCategory<OtherCategories>[] = [
  {
    name: 'website',
    label: 'Websites',
    description: 'Generate copy for the most common website pages',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/websites_category_a4cxvm.png',
  },
  {
    name: 'sales',
    label: 'Sales',
    description: 'Create materials to help you sell your product or business',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/sales_category_wuo78e.png',
  },
  {
    name: 'customer_support',
    label: 'Customer Support',
    description: 'Everything you need to support your customers (reply templates, FAQs etc.)',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/customer_support_category_unpfjm.png',
  },
  {
    name: 'recruiting',
    label: 'Recruiting',
    description: 'Close more deals with persuasive emails that drive action.',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/recruiting_category_kexz5c.png',
  },
]

export const GROUPS_V2: Array<Group> = [
  { name: 'Popular', channels: FOR_YOU_CHANNELS },
  { name: 'Tools', channels: flatMap(TOOLS_CHANNELS, (value) => value) },
  { name: 'Social media', channels: flatMap(SOCIAL_MEDIA_CHANNELS, (value) => value) },
  { name: 'Blog/SEO', channels: CONTENT_CHANNELS },
  { name: 'Marketplaces', channels: flatMap(MARKETPLACE_CHANNELS, (value) => value) },
  { name: 'Video', channels: flatMap(VIDEOS_CHANNELS, (value) => value) },
  { name: 'Ads', channels: ADS_CHANNELS },
  { name: 'Emails', channels: flatMap(EMAILS_CHANNELS, (value) => value) },
  { name: 'Product Descriptions', channels: PRODUCT_DESCRIPTIONS_CHANNELS },
  { name: 'Website', channels: WEBSITE_CHANNELS },
  { name: 'Sales', channels: SALES_CHANNELS },
  { name: 'Customer Service', channels: CUSTOMER_SUPPORT_CHANNELS },
  { name: 'Recruiting', channels: RECRUITING_CHANNELS },
]

export const CHANNELS_BY_ONBOARDING_SELECTIONS: CreationCategoryChannels = {
  social_media: {
    instagram: { title: 'Instagram', channels: SOCIAL_MEDIA_CHANNELS_V2.instagram },
    facebook: { title: 'Facebook', channels: SOCIAL_MEDIA_CHANNELS_V2.facebook },
    linkedin: { title: 'LinkedIn', channels: SOCIAL_MEDIA_CHANNELS_V2.linkedIn },
    x: { title: 'X/Twitter', channels: SOCIAL_MEDIA_CHANNELS_V2.twitter },
    tiktok: { title: 'Tiktok', channels: SOCIAL_MEDIA_CHANNELS_V2.tiktok },
    youtube: { title: 'YouTube', channels: SOCIAL_MEDIA_CHANNELS_V2.youtube },
  },
  email_newsletter: {
    newsletters: { title: 'Newsletters', channels: EMAILS_CHANNELS.newsletters },
    lifecycle: { title: 'Lifecycle', channels: EMAILS_CHANNELS.lifecycle },
    ecommerce: { title: 'Ecommerce', channels: EMAILS_CHANNELS.ecommerce },
    sales: { title: 'Sales', channels: EMAILS_CHANNELS.sales },
  },
  ads: {
    facebook: { title: 'Facebook', channels: [ChannelType.FacebookAds] },
    google: { title: 'Google', channels: [ChannelType.GoogleAds] },
    linkedin: { title: 'LinkedIn', channels: [ChannelType.LinkedInAds] },
    youtube: { title: 'YouTube', channels: [ChannelType.YoutubeAds] },
    bing: { title: 'Bing', channels: [ChannelType.BingAds] },
    tiktok: { title: 'Tiktok', channels: [ChannelType.TikTokAds] },
    amazon: { title: 'Amazon', channels: [ChannelType.AmazonAds] },
    pinterest: { title: 'Pinterest', channels: [ChannelType.PinterestAds] },
  },
  video: {
    youtube: { title: 'YouTube', channels: VIDEOS_CHANNELS.youtube },
    tiktok: { title: 'Tiktok', channels: VIDEOS_CHANNELS.tiktok },
    instagram: { title: 'Instagram', channels: VIDEOS_CHANNELS.instagram },
    facebook: { title: 'Facebook', channels: SOCIAL_MEDIA_CHANNELS.facebook },
    linkedin: { title: 'LinkedIn', channels: SOCIAL_MEDIA_CHANNELS.linkedIn },
    twitter: { title: 'X/Twitter', channels: SOCIAL_MEDIA_CHANNELS.twitter },
  },
  marketplace: {
    website: { title: 'Website', channels: [ChannelType.ProductLaunchWebsite] },
    'google-shop': { title: 'Google Shop', channels: [ChannelType.ProductLaunchGoogle] },
    'facebook-marketplace': { title: 'Facebook Marketplace', channels: ['facebook-marketplace'] },
    ebay: { title: 'Ebay', channels: ['ebay'] },
    poshmark: { title: 'Poshmark', channels: ['poshmark'] },
    depop: { title: 'Depop', channels: ['depop'] },
    mercari: { title: 'Mercari', channels: ['mercari'] },
    mercadolibre: { title: 'Mercadolibre', channels: ['mercadolibre'] },
    shopee: { title: 'Shopee', channels: ['shopee'] },
    lazada: { title: 'Lazada', channels: ['lazada'] },
    etsy: { title: 'Etsy', channels: [ChannelType.ProductLaunchEtsy, 'etsy'] },
    vinted: { title: 'Vinted', channels: ['vinted'] },
    amazon: { title: 'Amazon', channels: [ChannelType.ProductLaunchAmazon, 'amazon'] },
    shopify: { title: 'Shopify', channels: [ChannelType.ProductLaunchShopify, 'shopify-square'] },
    pinterest: { title: 'Pinterest', channels: ['pinterest'] },
    tiktok: { title: 'TikTok', channels: SOCIAL_MEDIA_CHANNELS.tiktok },
  },
  blogs_seo: { title: 'Blogs/SEO', channels: CONTENT_CHANNELS },
  website: { title: 'Website', channels: WEBSITE_CHANNELS },
  other: { title: '', channels: [] },
}

export const NEW_DESIGN_BUTTON_PROPS: Record<SocialMediaTabs, Partial<NewDocumentButtonProps | NewDocListItemProps>> = {
  popular: {},
  linkedIn: {
    title: 'Blank LinkedIn Visual Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_LI_Blank_cvpgbt.png',
    icon: <LinkedIn size={24} />,
    initialAspectRatioKey: 'linkedin-post',
  },
  instagram: {
    title: 'Blank Instagram Portrait Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_IG_Blank_ytaxau.png',
    icon: <Instagram size={24} />,
    initialAspectRatioKey: 'instagram-portrait-post',
  },
  facebook: {
    title: 'Blank Facebook Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_FB_Blank_lpvqmm.png',
    icon: <Facebook size={24} />,
    initialAspectRatioKey: 'facebook-post',
  },
  twitter: {
    title: 'Blank X/Twitter Visual Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Twitter_Blank_sqhoan.png',
    icon: <Twitter size={24} />,
    initialAspectRatioKey: 'twitter-post',
  },
  tiktok: {
    title: 'Blank Tik Tok Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Tiktok_Blank_mhqxod.png',
    icon: <TikTok size={24} />,
    initialAspectRatioKey: 'tik-tok-post',
  },
  youtube: {
    title: 'Blank YouTube Thumbnail',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_YT_Blank_yxxqwo.png',
    icon: <YouTube size={24} />,
    initialAspectRatioKey: 'youtube-channel-art',
  },
  pinterest: {
    title: 'Blank Pinterest Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Pinterest_Blank_thv8ls.png',
    icon: <Pinterest size={24} />,
    initialAspectRatioKey: 'pinterest',
  },
  whatsapp: {},
}

export const NEW_DESIGN_BUTTON_PROPS_V2: Partial<Record<SocialMediaTabs, Partial<NewDocumentButtonProps>>> = {
  linkedIn: {
    icon: <LinkedInBrand />,
    title: 'Start Blank',
    initialAspectRatioKey: 'linkedin-post',
  },
  instagram: {
    icon: <InstagramBrand />,
    title: 'Start Blank',
    initialAspectRatioKey: 'instagram-portrait-post',
  },
  facebook: {
    icon: <FacebookBrand />,
    title: 'Start Blank',
    initialAspectRatioKey: 'facebook-post',
  },
  twitter: {
    icon: <TwitterBrand />,
    title: 'Start Blank',
    initialAspectRatioKey: 'twitter-post',
  },
  tiktok: {
    icon: <TiktokBrand />,
    title: 'Start Blank',
    initialAspectRatioKey: 'tik-tok-post',
  },
  youtube: {
    icon: <YouTube size={35} />,
    title: 'Start Blank',
    initialAspectRatioKey: 'youtube-channel-art',
  },
  pinterest: {
    icon: <Pinterest size={35} />,
    title: 'Start Blank',
    initialAspectRatioKey: 'pinterest',
  },
}

export const WIZARD_CARD_INFO: Record<V2Channels, WizardCardInfo> = {
  [GenerationType.Campaign]: {
    icon: <></>,
    title: 'Multi-Channel Campaign',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/multi_campaign_ceesch.png',
  },
  [TurnInto.DocsIntoContent]: {
    icon: <></>,
    title: 'Turn Docs Into Content',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/turn_into_text_aesbjd.png',
  },
  [TurnInto.VideoIntoContent]: {
    icon: <></>,
    title: 'Turn Video Into Content',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/turn_into_video_jh5weu.png',
  },
  [TurnInto.WebsitesIntoContent]: {
    icon: <></>,
    title: 'Turn Websites Into Content',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/turn_into_website_yly8qm.png',
  },
  [TurnInto.AudioIntoContent]: {
    icon: <></>,
    title: 'Turn Audio Into Content',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/turn_into_audio_dvqfp8.png',
  },
  'linkedin-post': {
    title: 'LinkedIn Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_post_mqj4tt.png',
    icon: <LinkedInBrand />,
  },
  'linkedin-portrait-post': {
    title: 'LinkedIn Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_post_mqj4tt.png',
    icon: <LinkedInBrand />,
  },
  'google-my-business-post': {
    title: 'Google My Business Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_post_mqj4tt.png',
    icon: <Google />,
  },
  [GenerationType.LinkedInPlanning]: {
    title: 'Multiple LinkedIn Posts',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/multiple_linkedin_posts_wdss09.png',
    icon: <LinkedInBrand />,
  },
  'linkedin-profile-picture': {
    title: 'LinkedIn Profile Picture',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_profile_cx6adp.png',
    icon: <LinkedInBrand />,
  },
  'linkedin-banner': {
    title: 'LinkedIn Profile Banner',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_profile_banner_f0xpab.png',
    icon: <LinkedInBrand />,
  },
  [ChannelType.LinkedInAds]: {
    title: 'LinkedIn Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/linkedin_ad_w2whde.png',
    icon: <LinkedInBrand />,
  },
  'instagram-portrait-post': {
    title: 'Instagram Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_post_p2rdny.png',
    icon: <InstagramBrand />,
  },
  'instagram-story': {
    title: 'Instagram Story',
    icon: <InstagramBrand />,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_story_m0baz0.png',
  },
  'facebook-story': {
    title: 'Facebook Story',
    icon: <FacebookBrand />,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_story_m0baz0.png',
  },
  'instagram-reel': {
    title: 'Instagram Reel',
    icon: <InstagramBrand />,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_reel_tyhej9.png',
  },
  [GenerationType.InstagramPlanning]: {
    title: 'Multiple Instagram Posts',
    icon: <InstagramBrand />,
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_multiple_a6x0jg.png',
  },
  [ChannelType.InstagramReel]: {
    icon: <InstagramBrand />,
    title: 'Instagram Reel Script',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/instagram_script_u2lbm4.png',
  },
  'facebook-post': {
    icon: <FacebookBrand />,
    title: 'Facebook Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/facebook_post_m3ajok.png',
  },
  'facebook-portrait-post': {
    icon: <FacebookBrand />,
    title: 'Facebook Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/facebook_post_m3ajok.png',
  },
  'facebook-profile-picture': {
    icon: <FacebookBrand />,
    title: 'Facebook Profile Picture',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/facebook_profile_picture_qmtffr.png',
  },
  'facebook-cover': {
    icon: <FacebookBrand />,
    title: 'Facebook Profile Banner',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/facebook_profile_banner_iocl00.png',
  },
  [GenerationType.FacebookPlanning]: {
    icon: <FacebookBrand />,
    title: 'Multiple Facebook Posts',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/facebook_multiple_ymmnyt.png',
  },
  'twitter-post': {
    icon: <TwitterBrand />,
    title: 'X/Twitter Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/twitter_post_hij6ge.png',
  },
  'twitter-portrait-post': {
    icon: <TwitterBrand />,
    title: 'X/Twitter Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/twitter_post_hij6ge.png',
  },
  [ChannelType.TweetThread]: {
    icon: <TwitterBrand />,
    title: 'X/Twitter Thread',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/twitter_thread_rrpqxo.png',
  },
  'twitter-profile-picture': {
    icon: <TwitterBrand />,
    title: 'X/Twitter Profile Picture',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/Card_1_bzac2t.png',
  },
  'twitter-cover-image': {
    icon: <TwitterBrand />,
    title: 'X/Twitter Profile Banner',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/Card_2_hwycg0.png',
  },
  [GenerationType.TwitterPlanning]: {
    icon: <TwitterBrand />,
    title: 'Multiple X/Twitter Posts',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/multiple_twitter_posts_atrxcn.png',
  },
  'tik-tok-post': {
    icon: <TiktokBrand />,
    title: 'TikTok Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/tiktok_post_sbac6b.png',
  },
  'youtube-short': {
    icon: <YouTube size={35} />,
    title: 'YouTube Short',
    image: 'https://res.cloudinary.com/almanac/image/upload/v1748455804/blaze_assets/Card_umbquv.png',
  },
  [ChannelType.TikTokScript]: {
    icon: <TiktokBrand />,
    title: 'TikTok Script',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/tiktok_script_swa6vi.png',
  },
  'tik-tok-thumbnail': {
    icon: <TiktokBrand />,
    title: 'TikTok Thumbnail',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/tiktok_thumbnail_ix3iw3.png',
  },
  [ChannelType.YoutubeScript]: {
    icon: <YouTube size={35} />,
    title: 'YouTube Script',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/youtube_script_o6fltn.png',
  },
  [ChannelType.SMSMessages]: {
    icon: <></>,
    title: 'SMS Message',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/sms_message_bvznuq.png',
  },
  'whatsapp-sticker': {
    icon: <WhatsApp size={35} />,
    title: 'WhatsApp Sticker',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/whatsapp_sticker_hqcaq7.png',
  },
  pinterest: {
    icon: <Pinterest size={35} />,
    title: 'Pinterest Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/pinterest_post_ahnhhi.png',
  },
  [GenerationType.Brainstorm]: {
    icon: <></>,
    title: 'Content Ideas',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/content_ideas_ztatgi.png',
  },
  [GenerationType.ContentPlan]: {
    icon: <></>,
    title: 'Content Plan',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/content_plan_gxi6pz.png',
  },
  [ChannelType.BlogIdeas]: {
    icon: <></>,
    title: 'Blog Ideas',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/blog_ideas_jlg5rc.png',
  },
  [ChannelType.NewsletterIdeas]: {
    icon: <></>,
    title: 'Newsletter Ideas',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/newsletter_ideas_sly2gf.png',
  },
  [ChannelType.BlogPost]: {
    icon: <></>,
    title: 'Blog Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/blog_post_ig4yvr.png',
  },
  [ChannelType.CaseStudy]: {
    icon: <></>,
    title: 'Case Study',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/case_study_wclnel.png',
  },
  [ChannelType.PressRelease]: {
    icon: <></>,
    title: 'Press Release',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/press_release_fxngkz.png',
  },
  [GenerationType.Outline]: {
    icon: <></>,
    title: 'Content Outline',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/content_outline_moodv6.png',
  },
  [GenerationType.ContentBrief]: {
    icon: <></>,
    title: 'Content Brief',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/content_brief_o6fbwu.png',
  },
  [GenerationType.SEOPlanning]: {
    icon: <></>,
    title: 'Multiple Blog Posts',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/multiple_blog_posts_kjwuas.png',
  },
  [ChannelType.ProductLaunchWebsite]: {
    icon: <></>,
    title: 'Website Product Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/website_copy_qiledq.png',
  },
  [ChannelType.ProductLaunchGoogle]: {
    icon: <></>,
    title: 'Google Shop Product Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/google_shop_copy_dzyskq.png',
  },
  [ChannelType.ProductLaunchEtsy]: {
    icon: <></>,
    title: 'Etsy Product Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/etsy_copy_dhhgll.png',
  },
  [ChannelType.ProductLaunchAmazon]: {
    icon: <></>,
    title: 'Amazon Product Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/amazon_copy_k5d8qr.png',
  },
  [ChannelType.ProductLaunchShopify]: {
    icon: <></>,
    title: 'Shopify Product Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/shopify_copy_wpw0nh.png',
  },
  'shopify-square': {
    icon: <></>,
    title: 'Shopify Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/shopify_visuals_dsjrl9.png',
  },
  etsy: {
    icon: <></>,
    title: 'Etsy Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/etsy_visuals_whjbep.png',
  },
  amazon: {
    icon: <></>,
    title: 'Amazon Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/amazon_visuals_gze6b2.png',
  },
  ebay: {
    icon: <></>,
    title: 'Ebay Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ebay_visuals_rneuqc.png',
  },
  depop: {
    icon: <></>,
    title: 'Depop Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/depop_visuals_okgmim.png',
  },
  poshmark: {
    icon: <></>,
    title: 'Poshmark Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/poshmark_visuals_uzzdhl.png',
  },
  mercari: {
    icon: <></>,
    title: 'Mercari Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/mercari_visuals_o59gka.png',
  },
  mercadolibre: {
    icon: <></>,
    title: 'Mercado Libre Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/mercado_libre_visuals_f0vu2g.png',
  },
  shopee: {
    icon: <></>,
    title: 'Shopee Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/shopee_visuals_eml3n2.png',
  },
  lazada: {
    icon: <></>,
    title: 'Lazada Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/lazada_visuals_mkt9lj.png',
  },
  vinted: {
    icon: <></>,
    title: 'Vinted Product Visuals',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/vinted_visuals_m9yfex.png',
  },
  [ChannelType.Newsletter]: {
    icon: <></>,
    title: 'Newsletter Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/newsletter_copy_p6izgj.png',
  },
  [ChannelType.PromotionalEmailSequence]: {
    icon: <></>,
    title: 'Promotional Email Sequence',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/promo_sequence_aqz0ap.png',
  },
  [ChannelType.NurtureEmailSequence]: {
    icon: <></>,
    title: 'Nurture Sequence',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/nurture_sequence_wfizaa.png',
  },
  [ChannelType.WelcomeSeries]: {
    icon: <></>,
    title: 'Welcome Series',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/welcome_series_a5vtqm.png',
  },
  [ChannelType.DidntSignUp]: {
    icon: <></>,
    title: "Didn't Sign Up",
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/didnt_sign_up_tkyobp.png',
  },
  [ChannelType.AbandonedCart]: {
    icon: <></>,
    title: 'Abandoned Cart',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/abandoned_cart_zwkcqr.png',
  },
  [ChannelType.LostCustomer]: {
    icon: <></>,
    title: 'Lost Customer',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/lost_customer_t4q8fy.png',
  },
  [ChannelType.WarmOutboundEmailSequence]: {
    icon: <></>,
    title: 'Warm Outbound',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/warm_outbound_orfmju.png',
  },
  [ChannelType.ColdOutboundEmailSequence]: {
    icon: <></>,
    title: 'Cold Outbound',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/cold_outbound_gntlvm.png',
  },
  [ChannelType.LandingPage]: {
    icon: <></>,
    title: 'Landing Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/landing_page_v0i1jv.png',
  },
  [ChannelType.AboutUs]: {
    icon: <></>,
    title: 'About Us Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/about_us_q0ecbf.png',
  },
  [ChannelType.Pricing]: {
    icon: <></>,
    title: 'Pricing Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/pricing_e1nbri.png',
  },
  [ChannelType.Mission]: {
    icon: <></>,
    title: 'Mission Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/mission_f63p3o.png',
  },
  [ChannelType.FAQs]: {
    icon: <></>,
    title: 'FAQ Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/faq_hlryis.png',
  },
  [ChannelType.Impact]: {
    icon: <></>,
    title: 'Impact Page',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/impact_ukieab.png',
  },
  [ChannelType.OnePager]: {
    icon: <></>,
    title: 'Sales One Pager',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/one_pager_op7jkx.png',
  },
  [ChannelType.ProductDemo]: {
    icon: <></>,
    title: 'Product Demo Script',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/product_demo_script_kumjpf.png',
  },
  [ChannelType.PreCallChecklist]: {
    icon: <></>,
    title: 'Pre-Call Checklist',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/pre_call_checklist_g2duub.png',
  },
  [ChannelType.CallScript]: {
    icon: <></>,
    title: 'Sales Call Script',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/sales_call_script_jxrtcp.png',
  },
  [ChannelType.Testimonial]: {
    icon: <></>,
    title: 'Customer Testimonial',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/customer_research_brief_qwx4zx.png',
  },
  [ChannelType.Research]: {
    icon: <></>,
    title: 'Customer Research Brief',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/Card_tvfpyz.png',
  },
  [ChannelType.BattleCard]: {
    icon: <></>,
    title: 'Sales Battle Card',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/sales_battle_card_nalw3t.png',
  },
  [ChannelType.ReplyTemplates]: {
    icon: <></>,
    title: 'Customer Reply Templates',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/reply_templates_ibzxwg.png',
  },
  [ChannelType.HelpDocs]: {
    icon: <></>,
    title: 'Customer Help Docs',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/help_docs_nkwgla.png',
  },
  [ChannelType.ReturnPolicy]: {
    icon: <></>,
    title: 'Return Policy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/return_policy_jc7fjx.png',
  },
  [ChannelType.ShippingPolicy]: {
    icon: <></>,
    title: 'Shipping Policy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/shipping_policy_bfzpcq.png',
  },
  [ChannelType.CareInstructions]: {
    icon: <></>,
    title: 'Product Care Instructions',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/care_instructions_dp1nxo.png',
  },
  [ChannelType.BillingAndPayments]: {
    icon: <></>,
    title: 'Billing & Payments FAQs',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/billing_payments_faq_hihirr.png',
  },
  [ChannelType.PaymentConfirmation]: {
    icon: <></>,
    title: 'Payment Confirmation Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/payment_confirmation_yrnewx.png',
  },
  [ChannelType.CandidateNurtureSequence]: {
    icon: <></>,
    title: 'Candidate Nurture Sequence',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/candidate_nurture_sequence_pdkekg.png',
  },
  [ChannelType.JobDescription]: {
    icon: <></>,
    title: 'Job Description',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/job_description_sjdcl7.png',
  },
  [ChannelType.FacebookAds]: {
    icon: <></>,
    title: 'Facebook Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_cirth1.png',
  },
  [ChannelType.TikTokAds]: {
    icon: <></>,
    title: 'TikTok Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-2_hsqruz.png',
  },
  [ChannelType.YoutubeAds]: {
    icon: <></>,
    title: 'YouTube Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-3_tbmtf3.png',
  },
  [ChannelType.PinterestAds]: {
    icon: <></>,
    title: 'Pinterest Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-4_bfkhk3.png',
  },
  [ChannelType.GoogleAds]: {
    icon: <></>,
    title: 'Google Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-5_asnfuh.png',
  },
  [ChannelType.BingAds]: {
    icon: <></>,
    title: 'Bing Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-6_k5ydj9.png',
  },
  [ChannelType.AmazonAds]: {
    icon: <></>,
    title: 'Amazon Ad Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-7_p7d9mc.png',
  },
  'facebook-marketplace': {
    icon: <></>,
    title: 'Facebook Marketplace',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social_cirth1.png',
  },
  'youtube-profile-picture': {
    icon: <YouTube size={35} />,
    title: 'YouTube Profile Picture',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/youtube_profile_pic_w3nonw.png',
  },
  'youtube-channel-art': {
    icon: <YouTube size={35} />,
    title: 'YouTube Channel Art',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/youtube_channel_art_xjhlyh.png',
  },
  [DesignChannel.GoogleMyBusinessPost]: {
    icon: <></>,
    title: 'Google Business Profile Post',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/Type_Google_Ad_s6puvr.png',
  },
}

export const SOCIAL_MEDIA_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  'linkedin-post': {
    title: 'Post',
  },
  'linkedin-portrait-post': {
    title: 'Post',
  },
  [GenerationType.LinkedInPlanning]: {
    title: 'Multiple Posts',
  },
  'linkedin-profile-picture': {
    title: 'Profile Picture',
  },
  'linkedin-banner': {
    title: 'Profile Banner',
  },
  [ChannelType.LinkedInAds]: {
    title: 'Ad Copy',
  },
  'instagram-portrait-post': {
    title: 'Post',
  },
  'instagram-story': {
    title: 'Story',
  },
  'instagram-reel': {
    title: 'Reel',
  },
  [GenerationType.InstagramPlanning]: {
    title: 'Multiple Posts',
  },
  [ChannelType.InstagramReel]: {
    title: 'Script',
  },
  'facebook-post': {
    title: 'Post',
  },
  'facebook-portrait-post': {
    title: 'Post',
  },
  'facebook-profile-picture': {
    title: 'Profile Picture',
  },
  'facebook-cover': {
    title: 'Profile Banner',
  },
  [GenerationType.FacebookPlanning]: {
    title: 'Multiple Posts',
  },
  'twitter-post': {
    title: 'Post',
  },
  'twitter-portrait-post': {
    title: 'Post',
  },
  [ChannelType.TweetThread]: {
    title: 'Thread',
  },
  'twitter-profile-picture': {
    title: 'Profile Picture',
  },
  'twitter-cover-image': {
    title: 'Profile Banner',
  },
  [GenerationType.TwitterPlanning]: {
    title: 'Multiple Posts',
  },
  'tik-tok-post': {
    title: 'Post',
  },
  [ChannelType.TikTokScript]: {
    title: 'Script',
  },
  'tik-tok-thumbnail': {
    title: 'Thumbnail',
  },
  [ChannelType.YoutubeScript]: {
    title: 'Script',
  },
  'youtube-profile-picture': {
    title: 'Profile Picture',
  },
  'youtube-channel-art': {
    title: 'Channel Art',
  },
  [ChannelType.SMSMessages]: {
    icon: <WhatsApp size={35} />,
    title: 'Message Copy',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/whatsapp_message_fkgfxs.png',
  },
  'whatsapp-sticker': {
    title: 'Sticker',
  },
  pinterest: {
    title: 'Post',
  },
}

export const MARKETPLACE_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  [ChannelType.ProductLaunchWebsite]: {
    title: 'Website',
  },
  [ChannelType.ProductLaunchGoogle]: {
    title: 'Google Shop',
  },
  [ChannelType.ProductLaunchEtsy]: {
    title: 'Etsy',
  },
  [ChannelType.ProductLaunchAmazon]: {
    title: 'Amazon',
  },
  [ChannelType.ProductLaunchShopify]: {
    title: 'Shopify',
  },
  'shopify-square': {
    title: 'Shopify',
  },
  etsy: {
    title: 'Etsy',
  },
  amazon: {
    title: 'Amazon',
  },
  ebay: {
    title: 'Ebay',
  },
  depop: {
    title: 'Depop',
  },
  poshmark: {
    title: 'Poshmark',
  },
  mercari: {
    title: 'Mercari',
  },
  mercadolibre: {
    title: 'MercadoLibre',
  },
  shopee: {
    title: 'Shopee',
  },
  lazada: {
    title: 'Lazada',
  },
  vinted: {
    title: 'Vinted',
  },
  'facebook-marketplace': {
    title: 'Facebook Marketplace',
  },
}

export const ADS_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  [ChannelType.FacebookAds]: {
    icon: <></>,
    title: 'Facebook',
  },
  [ChannelType.LinkedInAds]: {
    icon: <></>,
    title: 'LinkedIn',
    image:
      'https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1/blaze_assets/create_new_v3/v2_card_images/ads/Social-1_oc5ogs.png',
  },
  [ChannelType.TikTokAds]: {
    icon: <></>,
    title: 'TikTok',
  },
  [ChannelType.YoutubeAds]: {
    icon: <></>,
    title: 'YouTube',
  },
  [ChannelType.PinterestAds]: {
    icon: <></>,
    title: 'Pinterest',
  },
  [ChannelType.GoogleAds]: {
    icon: <></>,
    title: 'Google',
  },
  [ChannelType.BingAds]: {
    icon: <></>,
    title: 'Bing',
  },
  [ChannelType.AmazonAds]: {
    icon: <></>,
    title: 'Amazon',
  },
}

export const EMAIL_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  [ChannelType.Newsletter]: {
    title: 'Copy',
  },
  [ChannelType.NewsletterIdeas]: {
    title: 'Ideas',
  },
  [ChannelType.PromotionalEmailSequence]: {
    title: 'Promo Sequence',
  },
  [ChannelType.NurtureEmailSequence]: {
    title: 'Nurture Sequence',
  },
  [ChannelType.WelcomeSeries]: {
    title: 'Welcome Series',
  },
  [ChannelType.DidntSignUp]: {
    title: "Didn't Sign Up",
  },
  [ChannelType.AbandonedCart]: {
    title: 'Abandoned Cart',
  },
  [ChannelType.LostCustomer]: {
    title: 'Lost Customer',
  },
  [ChannelType.WarmOutboundEmailSequence]: {
    title: 'Warm Outbound',
  },
  [ChannelType.ColdOutboundEmailSequence]: {
    title: 'Cold Outbound',
  },
}

export const OTHER_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  [ChannelType.LandingPage]: {
    title: 'Landing Page',
  },
  [ChannelType.AboutUs]: {
    title: 'About Us',
  },
  [ChannelType.Pricing]: {
    title: 'Pricing',
  },
  [ChannelType.Mission]: {
    title: 'Mission',
  },
  [ChannelType.FAQs]: {
    title: 'FAQ',
  },
  [ChannelType.Impact]: {
    title: 'Impact',
  },
  [ChannelType.OnePager]: {
    title: 'One Pager',
  },
  [ChannelType.ProductDemo]: {
    title: 'Product Demo Script',
  },
  [ChannelType.PreCallChecklist]: {
    title: 'Pre-Call Checklist',
  },
  [ChannelType.CallScript]: {
    title: 'Sales Call Script',
  },
  [ChannelType.Testimonial]: {
    title: 'Customer Testimonial',
  },
  [ChannelType.Research]: {
    title: 'Customer Research Brief',
  },
  [ChannelType.BattleCard]: {
    title: 'Sales Battle Card',
  },
  [ChannelType.ReplyTemplates]: {
    title: 'Reply Templates',
  },
  [ChannelType.HelpDocs]: {
    title: 'Help Docs',
  },
  [ChannelType.ReturnPolicy]: {
    title: 'Return Policy',
  },
  [ChannelType.ShippingPolicy]: {
    title: 'Shipping Policy',
  },
  [ChannelType.CareInstructions]: {
    title: 'Care Instructions',
  },
  [ChannelType.BillingAndPayments]: {
    title: 'Billing & Payments FAQs',
  },
  [ChannelType.PaymentConfirmation]: {
    title: 'Payment Confirmation',
  },
  [ChannelType.CandidateNurtureSequence]: {
    title: 'Candidate Nurture Sequence',
  },
  [ChannelType.JobDescription]: {
    title: 'Job Description',
  },
}

export const POPULAR_CARD_OVERRIDES: Partial<Record<ChannelKeyType, Partial<WizardCardInfo>>> = {
  [GenerationType.InstagramPlanning]: {
    icon: <></>,
  },
}

export const CREATE_NEW_COMBINED_CHANNELS_MAP: Partial<Record<ChannelKeyType, ChannelKeyType>> = {
  [ChannelType.InstagramPosts]: 'instagram-portrait-post',
  'instagram-square-post': 'instagram-portrait-post',
  'instagram-landscape-post': 'instagram-portrait-post',
  [ChannelType.Tweets]: 'twitter-post',
  [ChannelType.FacebookPost]: 'facebook-post',
  [ChannelType.LinkedInPosts]: 'linkedin-post',
}
